var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',[_c('div',{staticClass:"view-modal window-scorll"},[_c('div',{staticClass:"vue-lazy"},[_c('ul',_vm._l((_vm.img_lists),function(list,index){return _c('li',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(list),expression:"list"}],attrs:{"alt":""}})])}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e59f539","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-content/v-lazy.vue
// module id = null
// module chunks = 